<template>
   <div>
      <div id="card-element"></div>
      <div id="card-errors" role="alert" class="text-danger"></div>
   </div>
</template>

<script>

export default {
   name: 'Stripe',

   head() {
      return {
         script: [
            {
               body: true,
               hid: 'stripe',
               src: 'https://js.stripe.com/v3/',
               defer: true,
               // Changed after script load
               callback: () => {
                  this.stripe_script_loaded = true
                  this.configureStripe();
               }
            }
         ],
      }
   },


   data() {
      return {
         stripe_script_loaded: false,
         stripe: '',
         elements: '',
         card: '',
         style: {
            base: {
               color: '#666666',
               fontFamily: '"Montserrat", Helvetica, sans-serif',
               fontSmoothing: 'antialiased',
               fontSize: '16px',
               borderRadius: '100px',
               '::placeholder': {
                  color: '#666666'
               }
            },
            invalid: {
               color: '#fa755a',
               iconColor: '#fa755a'
            }
         },

      }
   },
   methods: {
      /*
          Includes Stripe.js dynamically
      */
      includeStripe(URL, callback) {
         let documentTag = document, tag = 'script',
            object = documentTag.createElement(tag),
            scriptTag = documentTag.getElementsByTagName(tag)[0];
         object.src = '//' + URL;
         if (callback) {
            object.addEventListener('load', function (e) {
               callback(null, e);
            }, false);
         }
         scriptTag.parentNode.insertBefore(object, scriptTag);
      },

      /*
      Configures Stripe by setting up the elements and
      creating the card element.
      */
      configureStripe() {
         try {
            this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY);

            this.elements = this.stripe.elements();
            this.card = this.elements.create('card', { style: this.style });

            this.card.mount('#card-element');
            this.listenForErrors();

         } catch (e) {
            console.log(e);
         }
      },

      listenForErrors() {
         this.card.on('change', function (event) {
            let displayError = document.getElementById('card-errors');
            if (event.complete) {
               // enable payment button
               displayError.textContent = '';
            } else if (event.error) {
               displayError.textContent = event.error.message;
            }
         });
      }

   },

   mounted() {
      this.includeStripe('js.stripe.com/v3/', function () {
         this.configureStripe();
      }.bind(this));

      // this.configureStripe();

   },
}
</script>

<style scoped>
.StripeElement {
   box-sizing: border-box;

   height: 40px;

   padding: 10px 12px;

   border: 2px solid #ebebeb;
   border-radius: 4px;
   background-color: #fcfcfc;

   box-shadow: 0 1px 3px 0 #e6ebf1;
   -webkit-transition: box-shadow 150ms ease;
   transition: box-shadow 150ms ease;
}

.StripeElement--focus {
   box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
   border-color: #fa755a;
}

.StripeElement--webkit-autofill {
   background-color: #fefde5 !important;
}

div#card-element {
   border-radius: 100px;
   height: 48px;
   padding: 16px 12px;
   background: #fff;
   border: 1px solid #DFDFDF;
   box-shadow: none;
}
</style>
